export default "__VITE_ASSET__3883ce23__"